import React, {
    createContext,
    Dispatch,
    SetStateAction,
    useContext,
    useState
} from 'react'
import { MatchingFilter, ResearchTypeFilter } from 'filterTypes'
import { toggleCheckboxListFilter } from 'utils/evidenceFilterUtil'

interface EvidenceFilterContextType {
    selectedResearchType: ResearchTypeFilter
    setSelectedResearchType: Dispatch<SetStateAction<ResearchTypeFilter>>
    exactMatchers: MatchingFilter[]
    handleExactMatcherFilterChange: (v: MatchingFilter) => void
}

const EvidenceFilterContext = createContext<
    EvidenceFilterContextType | undefined
>(undefined)

export const useEvidenceFilterContext = () => {
    const ctx = useContext(EvidenceFilterContext)
    if (!ctx)
        throw new Error(
            'useEvidenceFilterContext must be used within EvidenceFilterProvider'
        )
    return ctx
}

export const EvidenceFilterProvider: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    const [selectedResearchType, setSelectedResearchType] =
        useState<ResearchTypeFilter>('')
    const [exactMatchers, setExactMatchers] = useState<MatchingFilter[]>([])

    const handleExactMatcherFilterChange = (selectedFilter: MatchingFilter) => {
        setExactMatchers((prev) =>
            toggleCheckboxListFilter(prev, selectedFilter)
        )
    }

    const value = React.useMemo(
        () => ({
            selectedResearchType,
            setSelectedResearchType,
            exactMatchers,
            handleExactMatcherFilterChange
        }),
        [selectedResearchType, exactMatchers]
    )

    return (
        <EvidenceFilterContext.Provider value={value}>
            {children}
        </EvidenceFilterContext.Provider>
    )
}
